import { Component, inject, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DxButtonComponent } from 'devextreme-angular';
import moment from 'moment';
import { PARAMETRI_GIORNI_PRE_ALERT_ARTICOLI } from 'src/app/consts/const';
import { Dipendente } from 'src/app/models/dipendente';
import { Parametri } from 'src/app/models/parametri';
import { TipiArticoli } from 'src/app/models/tipi-articoli';
import { ArticoliConsegnatiScadenzeCompactComponent } from 'src/app/shared/components/articoli/articoli-consegnati-scadenze-compact/articoli-consegnati-scadenze-compact.component';
import { ChartPieTipologieComponent } from 'src/app/shared/components/articoli/chart-pie-tipologie/chart-pie-tipologie.component';
import { GridConsegneCompactComponent } from 'src/app/shared/components/articoli/grid-consegne-compact/grid-consegne-compact.component';
import { GridScadenzeDipendentiCompactComponent } from 'src/app/shared/components/dipendenti/grid-scadenze-dipendenti-compact/grid-scadenze-dipendenti-compact.component';
import { GestArticoliBaseComponent } from 'src/app/shared/components/gest-articoli-base/gest-articoli-base.component';
import { DipendentiService } from 'src/app/shared/services/dipendenti.service';
import { MansioniService } from 'src/app/shared/services/mansioni.service';
import { MovimentoArticoliService } from 'src/app/shared/services/movimento-articoli.service';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import { ParametriService } from 'src/app/shared/services/parametri.service';
import { RepartiService } from 'src/app/shared/services/reparti.service';
import { TipiArticoliService } from 'src/app/shared/services/tipi-articoli.service';
import { ConvertError } from 'src/app/utils/gestione-errori';
import { notificaMessaggio } from 'src/app/utils/notifiche-utils';

@Component({
  selector: 'app-dipendenti-dashboard',
  templateUrl: './dipendenti-dashboard.component.html',
  styleUrls: ['./dipendenti-dashboard.component.scss'],
  imports: [
    DxButtonComponent,
    GridConsegneCompactComponent,
    ChartPieTipologieComponent,
    ArticoliConsegnatiScadenzeCompactComponent,
    GridScadenzeDipendentiCompactComponent,
  ],
})
export class DipendentiDashboardComponent
  extends GestArticoliBaseComponent
  implements OnInit
{
  private route = inject(ActivatedRoute);
  private navService = inject(NavigatorService);
  private movService = inject(MovimentoArticoliService);
  private tipiArticoloService = inject(TipiArticoliService);
  private parametriService = inject(ParametriService);
  private dipendentiService = inject(DipendentiService);
  private repartoService = inject(RepartiService);
  private mansioneService = inject(MansioniService);

  @Input() idDipendente;

  dipendente: Dipendente;

  listTipiArticoli: TipiArticoli[];

  consegneList: any[];
  listConsegneAlert: any[];
  consegneScadute: any[];
  consegneProssimeAllaScadenza: any[];
  numConsegneScadute: number;
  numConsegneProssimeAllaScadenza: number;
  numDpiAssegnati: number;
  numTotConsegne: number;

  parametro: Parametri;
  giorniPreAlertArticoli = 0;
  repartoDescrizione: string;
  mansioneDescrizione: string;
  responsabile: Dipendente;
  responsabileNominativo: string;

  ngOnInit() {
    const idDipendenteParam = this.route.snapshot.paramMap.get('id');
    if (!idDipendenteParam || idDipendenteParam == '0') {
      this.navService.goToHome();
    } else {
      this.loadTipiArticoli();
      this.gteParametro();

      this.idDipendente = +idDipendenteParam;
      this.loadDipendente();
      this.loadConsegne();
    }
  }

  loadResponsanbile() {
    this.responsabileNominativo = '-';
    if (this.dipendente && this.dipendente.idResponsabile) {
      this.dipendentiService.get(this.dipendente.idResponsabile).subscribe({
        next: (res) => {
          if (res != null) {
            this.responsabileNominativo = res.nominativo;
          } else {
            this.responsabileNominativo = '-';
          }
        },
        error: (error) => {
          ConvertError(error, 'Errore recupero responsabile del dipendente');
        },
      });
    }
  }

  loadDipendente() {
    if (this.idDipendente > 0) {
      this.dipendentiService.get(this.idDipendente).subscribe({
        next: (res) => {
          if (res != null) {
            this.dipendente = res;
            this.loadReparto();
            this.loadMansione();
            this.loadResponsanbile();
          } else {
            notificaMessaggio('Dipendente non presente', 'warning');
            this.navService.goToHome();
          }
        },
        error: (error) => {
          ConvertError(error, 'Errore recupero dipendente');
        },
      });
    }
  }

  loadMansione() {
    this.mansioneDescrizione = '-';
    if (this.dipendente && this.dipendente.idMansione) {
      this.mansioneService.get(this.dipendente.idMansione).subscribe({
        next: (res) => {
          if (res != null) {
            this.mansioneDescrizione = res.descrizione;
          } else {
            this.mansioneDescrizione = '-';
          }
        },
        error: (error) => {
          ConvertError(error, 'Errore recupero mansione del dipendente');
        },
      });
    }
  }

  loadReparto() {
    this.repartoDescrizione = '-';
    if (this.dipendente && this.dipendente.idReparto) {
      this.repartoService.get(this.dipendente.idReparto).subscribe({
        next: (res) => {
          if (res != null) {
            this.repartoDescrizione = res.descrizione;
          } else {
            this.repartoDescrizione = '-';
          }
        },
        error: (error) => {
          ConvertError(error, 'Errore recupero reparto del dipendente');
        },
      });
    }
  }

  loadTipiArticoli() {
    this.tipiArticoloService.list().subscribe({
      next: (res) => {
        this.listTipiArticoli = res;
      },
      error: (error) => {
        ConvertError(error, 'Errore recupero tipi articolo');
      },
    });
  }

  gteParametro() {
    this.parametriService.get(PARAMETRI_GIORNI_PRE_ALERT_ARTICOLI).subscribe({
      next: (res) => {
        this.parametro = res;
        this.giorniPreAlertArticoli = this.parametro.valNum;
      },
      error: (error) => {
        ConvertError(error, 'Errore recupero parametro');
      },
    });
  }

  loadConsegne() {
    this.movService.listConsegne(this.idDipendente, 0).subscribe({
      next: (res) => {
        this.consegneList = res.filter((x) => x.articoloAttivo); // Solo per  articoli attivi

        const oggi = moment().format('YYYY-MM-DD'); // data odierna

        // Consegne scadute (datascadenza <= oggi)
        this.consegneScadute = this.consegneList.filter((c: any) => {
          const dataScadenza = moment(c.dataScadenza).format('YYYY-MM-DD');
          //return dataScadenza.isSameOrBefore(oggi, 'day');
          return dataScadenza <= oggi;
        });

        // Consegne prossime alla scadenza (entro x giorni da oggi)
        this.consegneProssimeAllaScadenza = this.consegneList.filter(
          (c: any) => {
            const dataScadenza = moment(c.dataScadenza).format('YYYY-MM-DD');
            //const diffGiorni = dataScadenza.diff(oggi, 'days');
            const diffGiorni = moment(dataScadenza).diff(moment(oggi), 'days');
            return diffGiorni > 0 && diffGiorni <= this.giorniPreAlertArticoli;
          },
        );

        //Unico le liste
        this.listConsegneAlert = [
          ...this.consegneScadute,
          ...this.consegneProssimeAllaScadenza,
        ];

        this.numConsegneScadute = this.consegneScadute.length;
        this.numConsegneProssimeAllaScadenza =
          this.consegneProssimeAllaScadenza.length;

        //Num Dpi assegnati
        this.numDpiAssegnati = this.consegneList.reduce(
          (acc, item) => acc + (item.qtaUltimaConsegna || 0),
          0,
        );
        //Totale consegne
        this.numTotConsegne = this.consegneList.reduce(
          (acc, item) => acc + (item.countConsegne || 0),
          0,
        );
      },
      error: (error) => {
        ConvertError(error, 'Errore recupero consegne');
      },
    });
  }

  goToDipendenteEdit() {
    this.navService.goToDipendentiEdt(this.idDipendente); // reindirizzo alla pagina di edt del dipendente
  }

  goToNuovaconsegna() {
    this.navService.goToNuovaConsegnaDipendente(this.idDipendente); // reindirizzo alla pagina per nuova consegna
  }
}
